export default __webpack_public_path__ + "static/media/19t.6b2e891a.jpg";